import React from "react";

const AreaDoClienteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1"
    id="Camada_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 3000 3000"
    {...props}
  >
    <style type="text/css">
      {`
    .st0-area { fill:#080413 !important; }
    .st1-area { fill:#CC3A00 !important; }
    .st2-area { fill:#F47E15 !important; }
  `}
    </style>
    <g>
      <g>
        <path
          className="st0-area"
          d="M1511.4,36.8C716.1,32.1,57.5,659.4,37.5,1464.6C17.5,2272,653,2944.3,1467.1,2962.8
			c798.9,18.2,1461.3-604,1494.5-1401.5C2996.1,735.2,2343.3,45.8,1511.4,36.8z M2761.8,1560.8c-12.7,246.3-90.4,470.3-232.5,671.9
			c-50.3,71.3-108,136.3-172.1,195.6c-1.9,1.8-3.4,4.1-6.2,4.7c-2.9-2.7-3.2-6.6-4.3-10c-52-151.9-135.9-283.8-250.7-395.6
			c-96.6-94.2-209-163.7-337.2-206.5c-62.1-20.7-125.9-33.7-191.4-39.4c-66.8-5.8-133.3-3.4-199.3,7.3
			c-106.4,17.2-205.9,53.7-298.6,108.8c-95.1,56.4-176.6,128.2-246.7,213.5c-2.3,2.8-4.7,5.6-7,8.4c-2.7-4.3-0.8-8.4,0.6-12.4
			c20.2-58,40.1-116.1,60.5-174.1c2-5.6,3.9-11.3,5.3-17.1c17.5-52,35.5-103.9,52.1-156.3c3.5-11.1,6.7-22.3,10-33.5
			c2.9-6.2,4.8-12.7,6.2-19.4c7.9-27.9,16.3-55.7,21.6-84.2c2.7-14.8-0.8-20.7-14.8-26.1c-18.3-7-37.6-8.7-56.8-10.3
			c-26.2-2.3-52.4-3.5-78.7-5c-5.4,0-10.9,0.3-16.3,0c-56.8-2.5-113.7-1.1-170.5-1.9c-27.3-0.4-54.4,3.3-81.7,2
			c-5.8,0.3-11.5,0.3-17.3,0c-50.6,0.7-101.2,1.8-151.8,2.8c-32.6,0.7-65.2,1-97.9,1.1c-2.4,0.2-4.9,0.2-7.3,0.1
			c-6.2-0.2-12.5-0.9-18.6,1c-4.5,0.9-9,0.8-13.5,0.6c-5.1-0.3-7.5-2.9-7.5-7.9c-4.5-68-2.9-136,3.8-203.7
			c10.1-101.9,32.2-201.3,66.8-297.7c66.9-187.1,171.6-350.1,315-487.7C790,431,984.6,325.3,1207.3,271.5
			c71.1-17.2,143.2-27.8,216.3-32c234.9-13.6,456.8,34,665,143.1c169.8,89,311.8,211.2,426.1,365.2
			c104.7,141.1,176.6,297.4,216.3,468.6C2757.2,1329.7,2767.8,1444.6,2761.8,1560.8z"
        />
      </g>
      <path
        className="st1-area"
        d="M807.2,1579.4c6.1,0.3,10.9,0.3,16.2,0.3c3.9,1.4,6.8,4.1,9.6,6.9c37.9,38,75.9,75.9,113.8,113.8
		c2.6,2.6,4.4,3.9,5.6,7.5l-5.1,19.3c-2.6,4.7-6.2,8.5-10,12.3c-35.1,35-70.1,70.1-105.2,105.1c-8.5,8.5-8.5,8.6,0.1,17.2
		c15,15.1,30.1,30.1,45.1,45.2c3,3,7.3,6.5,8.6,10.9c0,0.4-2.2,6.4-3.4,9.8c-20.9,60.5-41.9,120.9-62.9,181.4
		c-1.3,3.7-2.1,7.6-3.1,11.4c-14.3,19.7-28.8,39.1-42.7,59.1c-23.6,34-44.9,69.3-64.1,106c-1.4,2.6-2.2,5.6-4.7,7.5
		c-8.5-0.3-11.5-8.1-16.8-12.7c-8.3-7.4-8.1-7.8-15.8-0.1c-27,27-54,54.1-81.1,81c-2.8,2.8-5,7.4-10.4,5.9
		c-10.8-8.6-19.1-19.4-28.1-29.6c-35.2-40.1-67.8-82.2-98-126.2c-0.7-1.1-1.1-2.4-1.6-3.6c0.5-4.8,4.5-7.3,7.4-10.3
		c21.1-21.3,42.2-42.6,63.6-63.5c5.7-5.5,6.6-9,0.4-15.2c-36.1-35.5-71.7-71.5-107.5-107.2c-7.9-7.9-8.2-7.9-15.9-0.2
		c-9.9,9.8-19.7,19.9-29.8,29.6c-2.9,2.7-5.4,7.4-10.8,4.3c-7.3-10.8-11.5-23.1-16.8-34.8c-20.4-45.2-37.3-91.7-51.7-139.1
		c-0.4-1.2-0.4-2.6-0.6-3.9c6.4-2.7,8.8,3,11.9,6.1c31.9,31.6,63.6,63.5,95.4,95.2c10.1,10.1,10.1,10.1,20.2,0
		c35.8-35.8,71.6-71.5,107.3-107.3c8.2-8.2,8.2-8.4,0-16.6c-36.5-36.5-72.9-73-109.5-109.5c-7.7-7.7-8.1-7.7-15.8,0.1
		c-34.9,34.8-69.6,69.7-104.6,104.4c-3.5,3.5-5.8,8.1-9.9,11c-9-27.1-15.5-54.9-21.3-82.9c-10.2-48.5-18.6-97.2-22.6-146.6
		c-1.1-13.9-3-23-2.3-36.9c0,0,42.8-0.9,45-0.9c5.7,0.7,9.3,4.7,13.1,8.5c34.1,34.1,68.2,68.3,102.4,102.4c8.2,8.2,8.3,8.2,16.5,0.1
		c35.6-35.5,71.1-71,106.6-106.6c3.8-3.8,7.7-7.2,13-8.7c6.4,0,10.7,0,16.1,0.1c3,1.5,5.8,3.1,8.2,5.5
		c38.5,38.6,77.2,77.1,115.6,115.7c1.2,1.2,2,2.6,3,3.6c39.9-40,79.9-80,119.9-119.9C801.9,1582.3,804.7,1581.1,807.2,1579.4z"
      />
      <path
        className="st2-area"
        d="M1112.1,2428.2c17.5-15.4,33.5-32.5,50.4-48.6c7-6.7,13.9-13.5,21.8-19.1c4.6-3.3,9.3-6.5,14.8-8.1
		c8.1-2.4,12.7-0.4,16.3,7.2c3.3,7,4.4,14.6,5,22.3c1.6,23.4-0.4,46.7-2.5,69.9c-3.8,41.1-9.8,82-19.5,122.2
		c-12.6,52.2-27.6,103.6-48,153.3c-6.7,16.3-14.8,32-25,46.6c-16.6,24-39.4,38.3-67.7,44c-37,7.5-70.5-1.9-100-23.8
		c-33.1-24.6-55-58.4-71.4-95.9c-1-3.1,1.1-5,2.7-7c54.1-63.9,106.8-129.1,160.7-193.2c17.3-20.6,34.5-41.4,51.4-62.3
		C1104,2432.1,1107,2428.7,1112.1,2428.2z"
      />
      <path
        className="st2-area"
        d="M2106.2,2428c18.3-17.9,36.7-35.9,55-53.8c6.2-6.1,12.8-11.7,20.1-16.3c3.1-2,6.3-3.8,9.7-5
		c8.8-3.2,13.8-1,17.6,7.7c4.3,10,5,20.7,5.3,31.3c0.5,23.4-1.8,46.6-4.1,69.8c-5,50.1-13.8,99.6-27.6,148.1
		c-12.8,45.2-25.7,90.3-45.9,133c-7.7,16.3-17.1,31.6-29.4,45c-15.2,16.7-34.7,25.6-56.3,30.2c-36.2,7.7-69.3-1.6-98.4-22.5
		c-33.5-24.1-55.6-57.8-72.1-95.2c6.2-13.6,17.4-23.4,26.6-34.6c37.2-45.3,74.5-90.4,112-135.4c26.7-31.9,53.1-64.1,79.6-96.2
		C2100.6,2431.3,2103.6,2430,2106.2,2428z"
      />
      <path
        className="st1-area"
        d="M2106.2,2428c-14.3,17.4-28.6,34.8-43,52.1c-14.2,17.1-28.4,34.2-42.6,51.3c-11.9,14.3-23.7,28.6-35.5,42.9
		c-14.2,17.1-28.4,34.2-42.5,51.3c-14.6,17.6-29.1,35.3-43.7,52.9c-6.1,7.3-11.6,15.2-18.8,21.7c-7-11-11.3-23.3-16.1-35.3
		c-32.1-80.2-56.3-162.8-73.2-247.5c-2.7-13.3-5.2-26.8-2.9-40.6c2.2-12.6,8.1-17.1,21-14.6c11.6,2.3,22.1,7.4,31.9,13.8
		c24.8,16.2,49.4,32.7,74.2,49c10.9,7.2,10.1,9.7,17-5.3c10.8-23.6,21.7-47.2,32.8-70.6c5.9-12.4,12.8-24.1,22.8-33.7
		c12.4-11.8,24.6-12.8,38.6-2.7c11.6,8.3,19.9,19.6,27.2,31.6c15,24.7,29.6,49.8,44.4,74.6C2100,2422.5,2101,2427.3,2106.2,2428z"
      />
      <path
        className="st1-area"
        d="M1112.1,2428.2c-7.5,4.8-12,12.4-17.4,18.9c-27.7,33.1-54.9,66.6-82.4,99.7c-24.4,29.4-49.2,58.4-73.3,87.9
		c-17.4,21.3-34.9,42.6-52.8,63.5c-9.5-17.2-16.3-35.7-23.2-54c-28.4-75.2-50.6-152.1-65.9-231c-2-10.1-3.3-20.4-2.8-30.8
		c0.2-3.7,0.6-7.3,1.9-10.8c2.7-7.5,6.2-9.8,14.2-9.9c6.9-0.1,13.1,2.2,19.2,4.9c10.4,4.6,20.2,10.1,29.7,16.5
		c19.9,13.4,39.9,26.6,59.8,40c2.2,1.5,4.4,3,6.6,4.4c6.9,4.3,7.8,4.1,11.2-3.1c9.3-19.9,18.5-39.9,27.7-59.8c6-13,12-26,20.3-37.8
		c3.7-5.2,7.7-10.1,12.7-14c10.9-8.6,21.5-9.2,33.2-1.8c8,5.1,14.2,12,20,19.4c13.3,17.2,23.1,36.6,34.3,55.1
		c7.1,11.7,13.9,23.5,20.8,35.3C1107.5,2423.7,1109,2426.6,1112.1,2428.2z"
      />
      <path
        className="st2-area"
        d="M285.9,1849.8c0.1-3.9,2.2-6.7,4.9-9.4c37.2-37.1,74.4-74.4,111.6-111.5c5.8-5.8,6-5.8,11.7-0.1
		c39.1,39,78.2,78.1,117.2,117.2c5.9,5.9,5.9,6.1,0.3,11.7c-39,39.1-78.1,78.2-117.2,117.2c-6,6-6.2,6-12.5-0.3
		c-33.9-33.9-67.8-67.8-101.8-101.6c-2.7-2.7-4.7-6.7-9.3-6.9C288.6,1861,286.9,1855.5,285.9,1849.8z"
      />
      <path
        className="st2-area"
        d="M360,2044.1c4.3,0.2,6.4-3.2,8.9-5.7c11.6-11.5,23.2-22.9,34.6-34.7c3.7-3.8,6.1-3.6,9.8,0.1
		c39.5,39.7,79.1,79.2,118.7,118.9c0.7,0.7,1,1.6,1.5,2.4c-0.2,0.5-0.2,0.9-0.4,1.1c-26.6,27.1-53.3,54.1-80.6,80.5
		c-15.4-21.3-28.7-43.9-42.1-66.4c-16.6-28-32.2-56.6-46.2-86C362.5,2050.9,360.4,2047.8,360,2044.1z"
      />
      <path
        className="st2-area"
        d="M580.1,2366c3.6-1.4,5.7-4.5,8.3-7.1c27.6-27.5,55.1-55.1,82.7-82.6c2.6-2.6,4.7-5.6,8.4-7.3
		c9,6.8,15.4,16.4,24.7,23c-7.2,15.3-14.6,30.6-21.6,46c-12.2,27-22.7,54.7-32.3,82.7c-1.2,3.4-1.5,7.2-4.2,9.9
		c-3.2,0-4.5-2.7-6.3-4.4c-18.2-17.1-35.9-34.6-53.2-52.6C584.2,2371.2,581.5,2369.1,580.1,2366z"
      />
      <path
        className="st0-area"
        d="M1775.8,1675c-67,31.3-137.4,50.1-211,57.4c-95.7,9.6-189-1.7-279.6-33.3c-104.6-36.5-194.4-95.8-268.9-177.9
		c-81.4-89.7-135.3-193.9-157.5-312.9c-38.2-204.4,8.6-388.8,141.1-549.1c95.3-115.3,218.1-189.3,364.9-218.9
		c211.7-42.6,401.8,6.4,566.1,146.6c115,98.1,185,224,213.8,372.5c11.7,60.2,14.2,120.9,8.5,182.1c-4.5,48.7-15,96-29.3,142.6
		c-3.2,3-6.9,1.9-10.3,1c-58.1-15.1-116.2-30-172.6-50.7c-61.7-23.6-115.5-60.1-166.6-101.4c-23.3-18.8-47.1-37.5-75.7-47.9
		c-31.6-11.6-63.2-11.8-93.9,3.8c-14,7.1-24.1,18.8-34,30.5c-16.4,19.3-30.7,40.3-44.8,61.3c-33.2,49.4-78.6,80.4-136.2,94.4
		c-18.8,4.6-37.6,8.9-56.7,11.4c-14.8,2-28,8.1-40.3,16.5c-13.9,9.5-20,25.1-16,41.8c6.2,25.7,16.5,50,27.2,74
		c17,38.4,35.2,76.2,56.8,112.3c25.3,42.3,56.5,79.6,93.2,112.7c21.3,19.2,43.7,35.8,69.9,47.4c8.6,3.8,17.7,5.9,27,7.1
		c31.6,2.5,63,0.7,94.3-4.2c38.7-6.1,77.4-12.8,115.8-20.4C1765.8,1672.7,1771.2,1670,1775.8,1675z"
      />
      <path
        className="st2-area"
        d="M1775.8,1675c-9.1-0.9-17.7,2.3-26.4,3.9c-45.9,8.8-92,17-138.5,22.4c-18.8,2.2-29.5,2.1-48.4,0.7
		c-1.9-0.1-12.5-1.2-14.6-1.5c-1.2-4.4,2.9-7.2,5-9.9c33.6-41.7,68.3-82.5,102.3-123.8c36.8-44.7,73.8-89.1,110.8-133.7
		c37.8-45.6,75.7-91.1,113.4-136.7c14.8-17.9,29.6-36,44.6-53.7c4.2-5,7.5-12.3,16.3-10.9c57.7,20,116.4,36.2,175.6,51
		c2.5,0.6,5.2,0.9,7.8,1.3c17.6,6.1,36,9.5,54.1,13.8c55.3,13.3,110.7,26.5,164.9,44c9.9,3.2,19.3,7.2,28.6,11.7
		c20,9.6,34.4,24.7,44.9,43.9c6.5,11.9,8.5,24.2,6.6,37.6c-3.1,21.5-11.3,40-27.7,54.9c-16.2,14.9-34.1,26.6-54.7,34.1
		c-70.7,25.9-142.8,47.4-215.2,67.8c-103.2,29.1-207.8,52.3-312.8,74.2C1800.2,1668.8,1787.6,1670.2,1775.8,1675z"
      />
      <path
        className="st2-area"
        d="M806.3,1578.2c-1.3,1.5-2.4,3.2-3.8,4.6c-39.3,39.3-78.6,78.6-117.9,117.9c-1.6,1.6-3,3.6-5.3,4.4
		c-2.4-0.7-3.8-2.7-5.4-4.3c-39.3-39.3-78.6-78.6-117.9-117.9c-1.4-1.4-2.5-3-3.8-4.6c15.9-0.5,31.8-1.3,47.8-1.5
		c51.5-0.8,103-1,154.5-0.2C771.8,1576.8,789,1577.6,806.3,1578.2z"
      />
      <path
        className="st2-area"
        d="M536.1,1578.2c-3.9,3.6-7.9,7.1-11.6,10.9c-35.8,35.8-71.7,71.6-107.5,107.4c-1.6,1.6-3.4,3.2-4.9,4.9
		c-2.6,2.9-5,2.7-7.6-0.1c-1.6-1.7-3.3-3.3-4.9-5c-35.1-35.1-70.2-70.2-105.4-105.3c-3-3-6.4-5.7-9.7-8.6
		c57.2-1,114.5-1.9,171.7-2.9C482.9,1579.2,509.5,1578.7,536.1,1578.2z"
      />
      <path
        className="st2-area"
        d="M952.4,1708.1c-2.8-1.3-4.6-3.7-6.8-5.8c-40.2-40.2-80.5-80.4-120.7-120.7c-0.9-0.9-1.7-2-2.5-3
		c36.3,1.2,72.5,3.4,108.5,7.8c10.9,1.4,21.5,4.5,31.7,8.8c10.3,4.4,15,12.3,13,23.1C969.9,1648.7,959.7,1678.3,952.4,1708.1z"
      />
      <path
        className="st2-area"
        d="M885.1,1916.8c-5.6-3.7-44.7-43.7-59.7-58.8c-5-5-5-5.2-0.1-10.3c6.7-6.9,13.6-13.7,20.4-20.5
		c31.1-31.1,62.1-62.1,93.2-93.2c2.6-2.6,5-5.6,8.4-7.3C947.4,1726.8,885.6,1915.9,885.1,1916.8z"
      />
      <path
        className="st2-area"
        d="M679.7,1722.8c2.3,2.2,4.5,4.2,6.6,6.3c38.4,38.4,76.8,76.8,115.2,115.2c8.3,8.3,8.4,7.1,0.3,15.3
		c-38.4,38.4-76.8,76.8-115.2,115.2c-8.2,8.1-6.2,8.4-14.3,0.3c-26.4-26.4-52.8-52.8-79.2-79.1c-13-13-25.8-26-38.9-38.8
		c-3.6-3.5-4.1-5.9-0.3-9.8c41.4-41.1,82.6-82.3,123.9-123.5C677.9,1723.6,678.3,1723.5,679.7,1722.8z"
      />
      <path
        className="st2-area"
        d="M805.4,2124.8c-1.4,3.2-3.9,5-6,7.1c-37.7,37.7-75.4,75.4-113.1,113.1c-1.4,1.4-2.9,2.8-4.2,4.2
		c-2,2.2-3.8,2.2-5.8,0c-0.9-1-1.9-1.9-2.8-2.8c-38.9-38.9-77.7-77.7-116.6-116.6c-1.4-1.4-2.6-2.9-3.8-4.3c1.1-3,3.4-4.6,5.2-6.4
		c38.1-38.2,76.3-76.3,114.5-114.5c1.2-1.2,2.4-2.3,3.5-3.5c2-2.2,3.9-2.2,5.8,0c0.9,1,1.9,1.9,2.8,2.8
		c38.9,38.9,77.7,77.7,116.6,116.6C803,2121.9,804.2,2123.4,805.4,2124.8z"
      />
      <path
        className="st1-area"
        d="M1940.3,1231.8c-4.5,0.4-7,3.8-9.5,6.8c-12.2,14.4-24.4,28.9-36.5,43.5c-14.4,17.4-28.8,34.8-43.2,52.1
		c-14.2,17.1-28.4,34.2-42.6,51.3c-11.9,14.3-23.7,28.6-35.6,42.9c-14.2,17.1-28.4,34.2-42.5,51.4c-14.4,17.4-28.7,34.8-43.1,52.2
		c-17.8,21.5-35.5,43-53.3,64.4c-11.4,13.8-23,27.5-34.4,41.3c-14.6,17.6-29.1,35.3-43.7,53c-2.5,3.1-5.5,6.7-8,9.8
		c-14.8-0.5-27.1-7.4-39.9-14c-24.6-12.6-45.1-30.5-65-49.3c-43.3-41-78-88.1-104.8-141.3c-19.4-38.4-38.4-76.8-53.5-117.1
		c-4.3-11.5-8.2-23.2-10.8-35.3c-3.8-17.6,2.7-33,17.6-43.1c14.7-9.9,30.8-16,48.3-17.7c22.4-2.2,43.6-9,65-14.9
		c50.6-13.9,88.4-44.9,118-87.2c14.9-21.3,29.3-42.9,46-62.9c9.8-11.8,20.2-23.1,33.8-30.8c20-11.2,41.6-13.1,63.9-11.8
		c24.7,1.5,46.1,11.9,66.6,24.8c19.8,12.5,37.7,27.3,56,41.8c36.7,29,75.4,54.8,117.5,75.4
		C1917.6,1222.5,1929.1,1226.9,1940.3,1231.8z"
      />
    </g>
  </svg>
);

export default AreaDoClienteIcon;
